import { useEffect, useState } from 'react';

import styled from '@emotion/styled';
import { createPortal } from 'react-dom';

import { isServer } from 'src/utils/common';

import { defaultOverlay, overlay } from './PortalStyles';

type PortalProps = {
  show: boolean;
  // isMobile: boolean;
  onClick: () => void;
  children: JSX.Element;
  stylings?: any;
};

const DELAY = 200;

/**
 * delay the unmount of a component [necessary for animation]
 * @param isMounted component is mounted or not
 * @param delayTime time for which delay is required
 * @returns hook whether to show the div or not
 */
const useDelayUmount = (isMounted: boolean, delayTime: number) => {
  const [showDiv, setShowDiv] = useState(false);

  useEffect(() => {
    let timeoutId: any;
    if (isMounted && !showDiv) {
      setShowDiv(true);
    } else if (!isMounted && showDiv) {
      timeoutId = setTimeout(() => setShowDiv(false), delayTime); //delay our unmount
    }
    return () => clearTimeout(timeoutId); // cleanup mechanism for effects , the use of setTimeout generate a sideEffect
  }, [isMounted, delayTime, showDiv]);
  return showDiv;
};

const Overlay = styled.div`
  ${overlay}
`;

const Portal = ({ show, children, onClick, stylings }: PortalProps) => {
  const showDiv = useDelayUmount(show, DELAY);
  const portal = showDiv ? (
    <Overlay css={[stylings || defaultOverlay]} onClick={onClick}>
      {children}
    </Overlay>
  ) : null;

  if (isServer()) return null;

  return createPortal(
    portal,
    document.getElementById('modal-root') as Element | DocumentFragment
  );
};

export default Portal;
